export enum LoanStatusActionTypes {
    API_RESPONSE_SUCCESS = "@@loanStatus/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@loanStatus/API_RESPONSE_ERROR",
    GET_LOAN_STATUS = "@@loanStatus/GET_LOAN_STATUS",
    ADD_LOAN_STATUS = "@@loanStatus/ADD_LOAN_STATUS",
    UPDATE_LOAN_STATUS = "@@loanStatus/UPDATE_LOAN_STATUS",
    DELETE_LOAN_STATUS = "@@loanStatus/DELETE_LOAN_STATUS",
  }
  